<template>
	<div>
        <div v-show="parentShow">
            <Form :model="formItem" :label-width="100" inline>
                <Form-item label="门店编码">
                    <Input type="text" v-model="formItem.stcode"></Input>
                </Form-item>
                <Form-item label="门店名称">
                    <Input type="text" v-model="formItem.sname"></Input>
                </Form-item>
                <Form-item label="大区">
                    <Input type="text" v-model="formItem.area"></Input>
                </Form-item>
                <Form-item label="三级门店类型 ">
                    <Input type="text" v-model="formItem.thirdtype"></Input>
                </Form-item>
                <Form-item label="计划人姓名">
                    <Input type="text" v-model="formItem.username"></Input>
                </Form-item>
                <Form-item label="计划进店日期">
                    <Date-picker type="datetime" style="width:100%" format="yyyy-MM-dd" placeholder="选择日期和时间" @on-change="formItem.plandate=$event"></Date-picker>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="init">查询</Button>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="exportFn">导出报表</Button>
                </Form-item>
            </Form>
            <Table border :columns="columns" :data="data"></Table>
            <div class="clearfix page">
                <Page :total="pageTotal" class="fr" @on-change="pageChange" @on-page-size-change="pageSize" :current="formItem.start+1" placement="top" show-elevator show-sizer></Page>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data(){
        	return{
        		formItem: {
                    stcode:'',
                    sname:'',
                    area:'',
                    thirdtype:'',
                    username:'',
                    plandate:'',
                    start:0,
                    length:10,
                },
                temid:'',
                columns:[
                    {
                        title: '计划人姓名',
                        key: 'planname'
                    },{
                        title: '计划进店日期',
                        key: 'plandate'
                    },{
                        title: '大区',
                        key: 'area'
                    },{
                        title: '地级市',
                        key: 'pcity'
                    },{
                        title: '三级门店类型',
                        key: 'thirdtype'
                    },{
                        title: '门店编码',
                        key: 'stcode'
                    },{
                        title: '门店名称',
                        key: 'sname'
                    },{
                        title: '创建时间',
                        key: 'cdate'
                    }
                ],
                data:[],
                pageTotal:0,
                deleteShow:false,
        	}
        },
        watch:{
            $route(to,from){
                if(to.path == '/weekList'){
                    this.$store.dispatch('parentShowFn');
                    this.getData();
                }
            }
        },
        computed: {
            parentShow () {
                return this.$store.state.parentShow;
            }
        },
        created(){
            this.$store.dispatch('parentShowFn');
            this.getData();
        },
        methods:{
            exportFn(){
                var _this=this;
                this.$Modal.confirm({
                    content:'确认要导出报表吗？',
                    onOk(){
                        var jsonData=JSON.parse(JSON.stringify(_this.formItem));
                        delete jsonData['start'];
                        delete jsonData['length'];
                        var jsonArr=[];
                        for(var name in jsonData){
                            jsonArr.push(name+'='+jsonData[name]);
                        }
                        var jsonStr=jsonArr.join('&');
                        window.open('/checker_web/web/workorder/exportTaskPlan?'+jsonStr);
                    },
                });
            },
            getData(){
                var _this=this;
                this.$http.get('/web/workorder/getTaskPlanList',{
                    params:_this.formItem
                }).then(function(res){
                    _this.data=res.data;
                    _this.pageTotal=res.recordsTotal;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
            pageChange(res){
                this.formItem.start=res-1;
                this.getData();
            },
            pageSize(res){
                this.formItem.length=res;
                this.getData();
            },
            init(){
                this.formItem.start=0;
                this.getData();
            },
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/week/weekList.vue